import React, { useEffect, useState } from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Avatar from '@mui/material/Avatar';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import ArtistView from './ArtistView';
import YouTubeIcon from '@mui/icons-material/YouTube';
import VisibilityIcon from '@mui/icons-material/Visibility';
import axios from 'axios';
import BankDetailsModal from './BankDetailsModal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

export default function ArtistTable({ artists, getArtists, authToken }) {

  const [open, setOpen] = useState(false);
  const [id, setId] = useState("")
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [number, setNumber] = useState("")
  const [youtube, setYoutube] = useState("")
  const [img, setImg] = useState("")
  const [drives, setDrives] = useState(false);
  const [pa, setPa] = useState(false);
  const [decks, setDecks] = useState(false);
  const [solo, setSolo] = useState(false);
  const [duo, setDuo] = useState(false);
  const [dj, setDj] = useState(false);
  const [dancer, setDancer] = useState(false);
  const [instruments, setInstruments] = useState([]);

  // New state for bank details
  const [bankDetailsIds, setBankDetailsIds] = useState([]);

  // New state for bank details modal
  const [bankModalOpen, setBankModalOpen] = useState(false);
  const [selectedArtistId, setSelectedArtistId] = useState("");
  const [selectedArtistName, setSelectedArtistName] = useState("");

  // New state for search functionality
  const [searchTerm, setSearchTerm] = useState("");

  // Fetch bank details IDs on component mount
  useEffect(() => {
    fetchBankDetailsIds();
  }, []);

  const fetchBankDetailsIds = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API}/banking/get-all-bank-details-ids`,
        { headers: { 'AuthToken': authToken } }
      );

      setBankDetailsIds(response.data);
    } catch (error) {
      console.error('Failed to fetch bank details IDs:', error);
      // Don't show error to user, just log it
    }
  };

  const handleBankDetailsOpen = (artistId, artistName) => {
    setSelectedArtistId(artistId);
    setSelectedArtistName(artistName);
    setBankModalOpen(true);
  };

  const handleBankDetailsClose = () => {
    setBankModalOpen(false);
    setSelectedArtistId("");
    setSelectedArtistName("");
  };

  const handleOpen = (artist) => {
    const { _id, name, email, number, youtube, img, solo, duo, dj, dancer, drives, pa, decks, instruments } = artist;
    console.log(artist)
    setOpen(true)
    setId(_id); setName(name); setEmail(email); setNumber(number); setYoutube(youtube); setImg(img)
    setSolo(solo); setDuo(duo); setDj(dj); setDancer(dancer); setDrives(drives); setPa(pa); setDecks(decks)
    setInstruments(instruments || [])
  }
  const handleClose = () => {
    setId(""); setName(""); setEmail(""); setNumber(""); setYoutube(""); setImg("")
    setSolo(false); setDuo(false); setDj(false); setDancer(false); setDrives(false); setPa(false); setDecks(false)
    setInstruments([])
    setOpen(false)
  };


  function createData(_id, img, name, email, number, youtube, solo, duo, dj, dancer, drives, pa, decks, deviceNotificationsToken, instruments) {
    return { _id, img, name, email, number, youtube, solo, duo, dj, dancer, drives, pa, decks, deviceNotificationsToken, instruments };
  }

  // Filter artists based on search term
  const filteredArtists = artists.filter(artist =>
    artist.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  let sorted = filteredArtists.sort((a, b) => a.name !== b.name ? a.name < b.name ? -1 : 1 : 0)


  let rows = sorted.map((artist) => {
    const { _id, img, name, email, number, youtube, solo, duo, dj, dancer, drives, pa, decks, deviceNotificationsToken, instruments } = artist;

    return createData(_id, img, name, email, number, youtube, solo, duo, dj, dancer, drives, pa, decks, deviceNotificationsToken, instruments)
  })




  return (
    <TableContainer component={Paper} className="performers-table-container">

      <ArtistView
        name={name} setName={setName} email={email} number={number} setNumber={setNumber} id={id}
        img={img} setImg={setImg} youtube={youtube} setYoutube={setYoutube}
        solo={solo} setSolo={setSolo} duo={duo} setDuo={setDuo} dj={dj} setDj={setDj} dancer={dancer} setDancer={setDancer}
        drives={drives} setDrives={setDrives} pa={pa} setPa={setPa} decks={decks} setDecks={setDecks}
        instruments={instruments} setInstruments={setInstruments}
        handleClose={handleClose} open={open} getArtists={getArtists} />

      <BankDetailsModal
        open={bankModalOpen}
        onClose={handleBankDetailsClose}
        artistId={selectedArtistId}
        artistName={selectedArtistName}
        authToken={authToken}
      />

      {/* Search Input */}
      <Box sx={{ p: 2, borderBottom: '1px solid #e0e0e0' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Search performers by name..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: '#e0e0e0',
                },
                '&:hover fieldset': {
                  borderColor: '#3496d1',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#3496d1',
                },
              },
            }}
          />
          {searchTerm && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant="body2" color="text.secondary">
                {rows.length} of {artists.length} performers
              </Typography>
              <Button
                size="small"
                onClick={() => setSearchTerm("")}
                sx={{ minWidth: 'auto', px: 1 }}
              >
                Clear
              </Button>
            </Box>
          )}
        </Box>
      </Box>

      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell></TableCell>
            <TableCell align="left">Performer</TableCell>
            <TableCell align="left">Email</TableCell>
            <TableCell align="left">Number</TableCell>
            {/*<TableCell align="left">Drives</TableCell>*/}
            <TableCell align="left">Push</TableCell>
            <TableCell align="left">Youtube</TableCell>
            <TableCell align="left">Bank Details</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {
            rows.map((row) => (
              <TableRow onClick={() => { handleOpen(row); }}
                key={row.name}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  <Avatar alt={row.name} src={row.img} />

                </TableCell>
                <TableCell align="left">{row.name}</TableCell>
                <TableCell align="left">{row.email}</TableCell>
                <TableCell align="left">{row.number}</TableCell>
                <TableCell align="left">{row.deviceNotificationsToken ? 'Yes' : ''}</TableCell>
                <TableCell align="left">{row.youtube ? <a href={row.youtube} target='_blank'><YouTubeIcon sx={{ color: 'red' }} /></a> : <YouTubeIcon sx={{ color: 'grey' }} />}</TableCell>
                <TableCell align="left">
                  {bankDetailsIds.includes(row._id) && (
                    <VisibilityIcon
                      sx={{
                        color: '#3496d1',
                        cursor: 'pointer',
                        '&:hover': { color: '#2980b9' }
                      }}
                      onClick={(e) => {
                        e.stopPropagation(); // Prevent row click
                        handleBankDetailsOpen(row._id, row.name);
                      }}
                    />
                  )}
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
